<template>
  <div class="header-hello">
    <div class="header-hello-c">
      <div>
        <p>欢迎来到信用中国（甘肃）<span>｜</span></p>
        <p>黄河之滨·诚信之城</p>
      </div>
      <div>
        <p>咨询投诉<span>｜</span></p>
        <p>无障碍阅读<span>｜</span></p>
        <p>适老版</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {

}
</script>

<style scoped lang="scss">
.header-hello {
  width: 100%;
  background: #c9ecff;
  height: 50px;

  .header-hello-c {
    height: 50px;
    margin: auto;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    align-items: center;
    >div:nth-child(1) {
      >p:nth-child(2) {
        color: #3584F8;
      }
    }
    >div{
      display: flex;
      span{
        margin: 0 5px;
        color: #33333388;
      }
    }
  }
}
</style>
